<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="exTankOrderHeadings" :data="orders" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onOrderActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100" v-show="!loading">
                                <button class="btn btn-primary" @click="onAddOrderClick" id="btnOrdersDeliveryAddOrder" v-if="!company.suspended">Add Order</button>
                            </div>
                            <div class="w-100 text-danger" v-show="company.suspended">
                                Suspended, cannot place orders
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div>
                                    <label>Order Status</label>
                                    <bootstrap-select  :selectOptions="orderStatuses" :selectedOption="filter.orderStatusId" :elementId="'orderStatusFilterSelect'"
                                                       :returnSelectedOptionText="true"
                                                       @changeSelect="onOrderStatusSelect"></bootstrap-select>
                                </div>
                                <br>
                                <br>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <from-date-to-date-pickers  :title="'Date Created'"
                                                                    :fromDate="filter.fromDateCreated"
                                                                    :toDate="filter.toDateCreated"
                                                                    :elementId="'customerDateFilter'"
                                                                    :dateFormat="'DD/MM/YYYY'"
                                                                    @clearDatePicker="onDateFilterClearClick"
                                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="pr-3" v-if="showExpectedDateOfDeliveryFilter">
                                            <from-date-to-date-pickers  :title="'Expected Upliftment Date'"
                                                                        :fromDate="filter.expectedUpliftmentFromDate"
                                                                        :toDate="filter.expectedUpliftmentDateToDate"
                                                                        :elementId="'expectedDateOfDeliveryFilter'"
                                                                        :dateFormat="'DD/MM/YYYY'"
                                                                        @clearDatePicker="onExpectedUpliftmentFilterClearClick"
                                                                        @fromDateSelected="onExpectedUpliftmentFromDateSelect"
                                                                        @toDateSelected="onExpectedUpliftmentToDateSelect"></from-date-to-date-pickers>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
                
            </div>
        </div>
    </div>

    <!-- TODO: remove -->
    <div class="modal fade" id="stillInDevModal" tabindex="-1" aria-labelledby="stillInDevModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="stillInDevModalLabel">Still in development</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Still in development
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light" data-dismiss="modal">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <order-documents-modal
        :orderId="documentsModal.orderId"
        :heading="documentsModal.heading"
        :modalId="documentsModal.modalId"
        :showModal="documentsModal.showModal"
        @closeModal="onDocumentsModalClose"></order-documents-modal>

    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>
    
    <add-or-update-exTank-order-modal 
            :heading="orderForExTankModal.heading"
            :modalId="orderForExTankModal.modalId"
            :showModal="orderForExTankModal.showModal"
            :company="orderForExTankModal.company"
            @placeOrderOkClicked="onPlaceOrderOkClicked"></add-or-update-exTank-order-modal>
    
    <upload-bol-modal
        :orderId="uploadBolModal.orderId"
        :showModal="uploadBolModal.showModal"
        :modalId="uploadBolModal.modalId"
        @closeModal="onUploadBolModalClose"></upload-bol-modal>


    <div class="modal fade" :id="cancelOrderModalId" tabindex="-1" aria-labelledby="cancelOrderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="cancelOrderModalLabel">Cancel Order #{{selectedOrder.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Cancel Order? Are you sure?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        No
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onCancelYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
